import React, { useState } from "react";
import { MDBRow, MDBCol, MDBContainer } from "mdbreact";
import { FindARep, DownloadCatalog } from "./explore-section-query-container";
import { useMediaQuery } from "react-responsive";

const ExploreSection = () => {
  const [mouseEnter, setMouseEnter] = useState(false);
  const betweenMobileAndTablet = useMediaQuery({ query: "(max-width: 600px)" });

  const slide_animation = !betweenMobileAndTablet && mouseEnter;
  return (
    <MDBContainer
      fluid
      className="explore-wrapper p-0"
      onMouseEnter={() => setMouseEnter(true)}
    >
      <MDBRow className="explore-wrapper-inner">
        <MDBCol
          lg="6"
          className={`explore-card-left ${slide_animation && "show"}`}
        >
          <FindARep />
        </MDBCol>
        <MDBCol
          lg="6"
          className={`explore-card-right ${slide_animation && "show"}`}
        >
          <DownloadCatalog />
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};

export default ExploreSection;
